angular.module('eCareVault.common.filters', []);